import script from "./TransportationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TransportationForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__